import style from '../css/Report.module.css';
import { useState, useEffect } from 'react';

function SideRC({
  handleGeneratePDF,
  jsonData,
  fetchReportData,
  sendHTMLToServer,
  selectAll,
  deselectAll,
  setPdfUrl, // PDF URL을 저장할 state 변경 함수 추가
  pdfUrl, // 현재 화면 상태 확인용 (null: ReportCard / URL: Content)

  loading, setLoading,
  studentId, // 읽기 전용
  startDate, setStartDate, // 변경 가능
  endDate, setEndDate // 변경 가능  
}) {

  const [selectedOptions, setSelectedOptions] = useState({
    printType: '',  // 'LIST'
    studentUID: '',

    isHeader: false,   // 헤더표시 체크박스
    isPrintDate: true,    // 출력시간,

    materialType: '', // 'WORD'
    targetType: '',
    shuffle1: 'random',
    shuffle2: 'view',
    wordStep: 'step1',
    sentenceStep: 'step1',
  });

  const [shareDialogVisible, setShareDialogVisible] = useState(false);
  // const openShareDialog = () => setShareDialogVisible(true);
  // const closeShareDialog = () => setShareDialogVisible(false);

  const openShareDialog = () => {
    setShareDialogVisible(true);
  };

  const closeShareDialog = () => {
    setShareDialogVisible(false); // 다이얼로그 닫기
  };

  useEffect(() => {
    if (jsonData) {
      const reportType = jsonData?.jsonData.reportType || 'REPORT';

      // JSON 데이터를 기반으로 상태 업데이트
      setSelectedOptions((prev) => ({
        ...prev,
        printType: reportType === 'WORKBOOK' ? 'LIST' : reportType, // WORKBOOK이면 LIST 기본 설정
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonData]);

  // Option 체크박스 핸들러
  const handleOptionCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: checked, // name 속성을 이용해 동적으로 상태 업데이트
    }));
  };

  const handleSendClick = async () => {
    try {
      setLoading(true);

      const bodyData = {
        payload: {
          ...jsonData?.jsonData,
        },
        printOption: {
          isHeader: selectedOptions.isHeader,
          isPrintDate: selectedOptions.isPrintDate,
        },
      };

      const response = await sendHTMLToServer(bodyData);
      if (response) {
        setPdfUrl(response); // 받아온 URL을 ViewContainerRC에 저장
      } else {
        console.error("URL을 받아오지 못했습니다.");
      }
    } catch (error) {
      console.error("전송 오류:", error);
    } finally {
      setLoading(false);
    }
  };

  // 최근 1주일 설정 함수
  const setRecentWeek = () => {
    const today = new Date();
    const end = today.toISOString().split('T')[0]; // 오늘 날짜 (YYYY-MM-DD)

    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 6); // 오늘 포함 7일 전 (6일 차감)
    const start = weekAgo.toISOString().split('T')[0];

    setStartDate(start);
    setEndDate(end);
  };

  // 최근 1개월 설정 함수
  const setRecentMonth = () => {
    const today = new Date();
    const end = today.toISOString().split('T')[0]; // 오늘 날짜

    const monthAgo = new Date(today);
    monthAgo.setDate(monthAgo.getDate() - 29); // 오늘 포함 30일 전
    const start = monthAgo.toISOString().split('T')[0];

    setStartDate(start);
    setEndDate(end);
  };

  // ReportCard 화면인지, Content 화면인지 확인
  const isReportCardView = (pdfUrl === null); // true면 ReportCard, false면 Content

  const { printType } = selectedOptions;

  return (
    // <div className={style.side}>
    <div className={`${style.side} ${style.scrollable}`}>

      {(selectedOptions.printType === 'REPORT') &&
        (
          <>
            {/* <div className={style.selectContainer} style={{ marginTop: "4px", marginBottom: "8px" }}> */}
            <br />
            <div className={style.selectContainer}>
              <div className={style.selectRow}>
                <label htmlFor="printType" className={style.selectLabel}>인쇄 종류</label>
                <select
                  id="printType"
                  name="printType"
                  className={style.select}
                  value={printType}
                  // onChange={handleOptionChange}
                  disabled={printType === 'SELFSCORING' || printType === 'TEST' || printType === 'REPORT'}
                >
                  {jsonData.jsonData.reportType === 'WORKBOOK' && (
                    <>
                      <option value="LIST">교재</option>
                      <option value="WORKSHEET">워크시트</option>
                    </>
                  )}
                  {(jsonData.jsonData.reportType === 'SELFSCORING' ||
                    // jsonData.jsonData.reportType === 'TEST' ||
                    jsonData.jsonData.reportType === 'REPORT') && (
                      <option value={printType}>성적표</option>
                    )}
                  {jsonData.jsonData.reportType === 'TEST' && (
                    <option value="TEST">시험지</option>
                  )}
                </select>
              </div>
            </div>
            <hr
              className={style.sectionDividerLight}
              style={{ marginTop: "8px", marginBottom: "0px" }}
            />
          </>
        )}

      <div className={style.selectContainer} style={{ marginBottom: "0px" }}>
        <h3 style={{ marginBottom: "4px", fontSize: "14px" }}>조회 일시 선택</h3>

        <div className={style.selectRow}>
          <input
            type="date"
            id="startDate"
            name="startDate"
            className={style.select}
            value={startDate || ''}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={!isReportCardView}
          />
          &nbsp;~&nbsp;
          <input
            type="date"
            id="endDate"
            name="endDate"
            className={style.select}
            value={endDate || ''}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={!isReportCardView}
            style={{ gap: "0px" }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", backgroundColor: "", marginTop: "4px" }}>
          <div className={`${style.buttonGroupHorizontal}`} style={{ justifyContent: "center", width: "80%", marginBottom: "10px" }}>
            <button className={style.buttonThree} onClick={setRecentWeek} disabled={!isReportCardView}>최근 1주일</button>
            <button className={style.buttonThree} onClick={setRecentMonth} disabled={!isReportCardView}>최근 1개월</button>
          </div>
        </div>

        <div className={style.centeredButtonWrapper}>
          <button
            className={style.centeredButton}
            onClick={fetchReportData}
            disabled={!isReportCardView}
          >성적 조회</button>
        </div>
      </div>

      <hr
        className={style.sectionDividerLight}
        style={{ marginTop: "12px", marginBottom: "0px" }}
      />

      <div
        className={style.selectContainer}
        style={{ marginTop: "0px", marginBottom: "0px" }}
      >
        <h3 style={{ marginBottom: "4px", fontSize: "14px" }}>성적표 항목 선택</h3>
        <div className={style.buttonGroupHorizontal}>
          <button onClick={selectAll} disabled={!isReportCardView} className={style.buttonThree}>전체 선택</button>
          <button onClick={deselectAll} disabled={!isReportCardView} className={style.buttonThree}>선택 해제</button>
        </div>
      </div>

      <hr
        className={style.sectionDividerLight}
        style={{ marginTop: "12px", marginBottom: "0px" }}
      />

      <div className={style.selectContainer} style={{ marginTop: "0px", marginBottom: "0px" }}>
        <h3 style={{ marginBottom: "4px", fontSize: "14px" }}>기타 옵션</h3>
        <div className={style.selectRow}>
          <div className={style.checkboxRow}>
            <input
              type="checkbox"
              id="isHeader"
              name="isHeader"
              checked={selectedOptions.isHeader}
              disabled={!isReportCardView}
              onChange={handleOptionCheckboxChange}
            />
            <label htmlFor="isHeader" className={style.selectLabel}>Header 표시</label>
          </div>
        </div>

        <div className={style.selectRow}>
          <div className={style.checkboxRow}>
            <input
              type="checkbox"
              id="isPrintDate"
              name="isPrintDate"
              checked={selectedOptions.isPrintDate}
              disabled={!isReportCardView}
              onChange={handleOptionCheckboxChange}
            />
            <label htmlFor="isPrintDate" className={style.selectLabel}>출력 시간</label>
          </div>
        </div>

      </div>

      <hr
        className={style.sectionDividerLight}
        style={{ marginTop: "12px", marginBottom: "0px" }}
      />

      <div
        className={style.selectContainer}
        style={{ marginTop: "24px" }}
      >
        {!isReportCardView && (
          <div className={style.centeredButtonWrapper}>
            <button
              className={`${style.centeredButton} ${style.buttonThree}`}
              onClick={openShareDialog}
            >
              공유
            </button>
          </div>
        )}

        {isReportCardView && (
          <div className={style.centeredButtonWrapper}>
            <button
              className={`${style.centeredButton} ${style.buttonTwo}`}
              onClick={handleSendClick}
            >
              만들기
            </button>
          </div>
        )}

        {!isReportCardView && (
          <div className={style.centeredButtonWrapper}>
            <button
              className={`${style.centeredButton} ${style.buttonThree}`}
              onClick={() => setPdfUrl(null)}
            >
              설정 되돌아가기
            </button>
          </div>
        )}
      </div>

      {/* 공유 Dialog */}
      {shareDialogVisible && (
        <div className={style.dialogOverlay}>
          <div className={style.dialog}>
            <h3>공유하기</h3>
            <p style={{ marginBottom: '4px' }}>아래 링크를 복사하여 공유하세요.</p>
            <p style={{ color: 'red', fontWeight: 'bold', marginLeft: '4px', marginTop: '4px' }}>(해당 링크는 1개월간 유효합니다.)</p>
            <div className={style.shareContainer}>
              <input
                type="text"
                value={pdfUrl}
                readOnly
                className={style.shareInput}
              />
              <button className={style.button} onClick={() => navigator.clipboard.writeText(`${pdfUrl}`)}>
                복사
              </button>
            </div>
            <br />
            <button className={style.button} onClick={closeShareDialog}>닫기</button>
          </div>
        </div>
      )}

    </div>
  );
}

export default SideRC;
